import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'puzzle',
  data: function data() {
    return {
      moveStart: '',
      displayTips: false,
      verification: false,
      randomX: null,
      randomY: null,
      imgRandom: '',
      left_Num: 0,
      dataWidth: 300,
      dataHeight: 150,
      isShow: false,
      isSuccess: false
    };
  },
  props: {
    width: {
      type: [String, Number],
      default: 300
    },
    height: {
      type: [String, Number],
      default: 220
    },
    cropImage: {
      type: [Boolean],
      default: false
    },
    puzzleImgList: {
      type: Array,
      default: function _default() {
        return [require("../../assets/img/EMP\u767B\u5F55\u9A8C\u8BC1.png"), require("../../assets/img/EMP\u767B\u5F55\u9A8C\u8BC1.png"), require("../../assets/img/EMP\u767B\u5F55\u9A8C\u8BC1.png"), require("../../assets/img/EMP\u767B\u5F55\u9A8C\u8BC1.png")];
      }
    },
    PL_Size: {
      type: [Number],
      default: 48
    },
    padding: {
      type: [Number],
      default: 30
    },
    onSuccess: {
      type: Function,
      default: function _default() {}
    },
    onError: {
      type: Function,
      default: function _default() {}
    }
  },
  methods: {
    mouseenter: function mouseenter() {
      this.isShow = true;
    },
    mouseleave: function mouseleave() {
      this.isShow = false;
    },
    /* 刷新 */refreshImg: function refreshImg() {
      var imgRandomNum = this.$common.RandomNum(0, this.puzzleImgList.length);
      this.imgRandom = this.puzzleImgList[imgRandomNum];
      this.initCanvas();
    },
    /* 画布初始化 */initCanvas: function initCanvas() {
      this.clearCanvas();
      // let self = this

      var w = this.dataWidth;
      var h = this.dataHeight;
      console.log(w);
      var PL_Size = 48;
      var padding = 20;
      var MinN_X = padding + PL_Size;
      var MaxN_X = w - padding - PL_Size - PL_Size / 6;
      var MaxN_Y = padding;
      var MinN_Y = h - padding - PL_Size - PL_Size / 6;
      this.randomX = this.$common.RandomNum(MinN_X, MaxN_X);
      this.randomY = this.$common.RandomNum(MinN_Y, MaxN_Y);
      var X = this.randomX;
      var Y = this.randomY;
      this.left_Num = -X + 10;
      var d = PL_Size / 3;
      var c = this.$refs.puzzleBox;
      var c_l = this.$refs.puzzleLost;
      var c_s = this.$refs.puzzleShadow;
      var ctx = c.getContext('2d');
      var ctx_l = c_l.getContext('2d');
      var ctx_s = c_s.getContext('2d');
      ctx.globalCompositeOperation = 'xor';
      ctx.shadowBlur = 10;
      ctx.shadowColor = '#fff';
      ctx.shadowOffsetX = 3;
      ctx.shadowOffsetY = 3;
      ctx.fillStyle = 'rgba(0,0,0,0.7)';
      ctx.beginPath();
      ctx.lineWidth = '1';
      ctx.strokeStyle = 'rgba(0,0,0,0)';
      ctx.moveTo(X, Y);
      ctx.lineTo(X + d, Y);
      ctx.bezierCurveTo(X + d, Y - d, X + 2 * d, Y - d, X + 2 * d, Y);
      ctx.lineTo(X + 3 * d, Y);
      ctx.lineTo(X + 3 * d, Y + d);
      ctx.bezierCurveTo(X + 2 * d, Y + d, X + 2 * d, Y + 2 * d, X + 3 * d, Y + 2 * d);
      ctx.lineTo(X + 3 * d, Y + 3 * d);
      ctx.lineTo(X, Y + 3 * d);
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
      var img = new Image();
      img.src = this.imgRandom;
      img.onload = function () {
        ctx_l.drawImage(img, 0, 0, w, h);
      };
      ctx_l.beginPath();
      ctx_l.strokeStyle = 'rgba(0,0,0,0)';
      ctx_l.moveTo(X, Y);
      ctx_l.lineTo(X + d, Y);
      ctx_l.bezierCurveTo(X + d, Y - d, X + 2 * d, Y - d, X + 2 * d, Y);
      ctx_l.lineTo(X + 3 * d, Y);
      ctx_l.lineTo(X + 3 * d, Y + d);
      ctx_l.bezierCurveTo(X + 2 * d, Y + d, X + 2 * d, Y + 2 * d, X + 3 * d, Y + 2 * d);
      ctx_l.lineTo(X + 3 * d, Y + 3 * d);
      ctx_l.lineTo(X, Y + 3 * d);
      ctx_l.closePath();
      ctx_l.stroke();
      ctx_l.shadowBlur = 10;
      ctx_l.shadowColor = 'black';
      ctx_l.clip();
      ctx_s.beginPath();
      ctx_s.lineWidth = '1';
      ctx_s.strokeStyle = 'rgba(0,0,0,0)';
      ctx_s.moveTo(X, Y);
      ctx_s.lineTo(X + d, Y);
      ctx_s.bezierCurveTo(X + d, Y - d, X + 2 * d, Y - d, X + 2 * d, Y);
      ctx_s.lineTo(X + 3 * d, Y);
      ctx_s.lineTo(X + 3 * d, Y + d);
      ctx_s.bezierCurveTo(X + 2 * d, Y + d, X + 2 * d, Y + 2 * d, X + 3 * d, Y + 2 * d);
      ctx_s.lineTo(X + 3 * d, Y + 3 * d);
      ctx_s.lineTo(X, Y + 3 * d);
      ctx_s.closePath();
      ctx_s.stroke();
      ctx_s.shadowBlur = 20;
      ctx_s.shadowColor = 'black';
      ctx_s.fill();
    },
    /* 通过重置画布尺寸清空画布，这种方式更彻底 */clearCanvas: function clearCanvas() {
      var c = this.$refs.puzzleBox;
      var c_l = this.$refs.puzzleLost;
      var c_s = this.$refs.puzzleShadow;
      c.setAttribute('height', c.getAttribute('height'));
      c_l.setAttribute('height', c.getAttribute('height'));
      c_s.setAttribute('height', c.getAttribute('height'));
      // c.height = c.height
      // c_l.height = c_l.height
      // c_s.height = c_s.height
    },
    /* 按住滑块后初始化移动监听，记录初始位置 */startMove: function startMove(e) {
      console.log(e);
      e = e || window.event;
      this.$refs.sliderBtn.style.backgroundPosition = '0 -216px';
      this.moveStart = e.pageX || e.targetTouches[0].pageX;
      this.addMouseMoveListener();
    },
    /* 滑块移动 */moving: function moving(e) {
      var self = this;
      e = e || window.event;
      var moveX = e.pageX || e.targetTouches[0].pageX;
      var d = moveX - self.moveStart;
      var w = self.dataWidth;
      var PL_Size = 48;
      var padding = 20;
      if (self.moveStart === '') {
        return '';
      }
      if (d < 0 || d > w - padding - PL_Size) {
        return '';
      }
      self.$refs.sliderBtn.style.left = d + 'px';
      self.$refs.sliderBtn.style.transition = 'inherit';
      self.$refs.puzzleLost.style.left = d + 'px';
      self.$refs.puzzleLost.style.transition = 'inherit';
      self.$refs.puzzleShadow.style.left = d + 'px';
      self.$refs.puzzleShadow.style.transition = 'inherit';
    },
    /* 移动结束，验证并回调 */moveEnd: function moveEnd(e) {
      var self = this;
      e = e || window.event;
      var moveEnd_X = (e.pageX || e.changedTouches[0].pageX) - self.moveStart;
      var ver_Num = self.randomX - 10;
      var deviation = 4;
      var Min_left = ver_Num - deviation;
      var Max_left = ver_Num + deviation;
      if (self.moveStart !== '') {
        if (Max_left > moveEnd_X && moveEnd_X > Min_left) {
          self.displayTips = true;
          self.verification = true;
          // setTimeout(function () {
          //   self.displayTips = false
          //   self.initCanvas()
          // }, 1000)
          /* 成功的回调函数 */
          self.isSuccess = true;
          self.removeMouseMoveListener();
          self.onSuccess();
        } else {
          self.displayTips = true;
          self.verification = false;
          setTimeout(function () {
            self.displayTips = false;
          }, 2000);
          if (typeof self.$refs.sliderBtn !== 'undefined' && typeof self.$refs.puzzleLost !== 'undefined' && typeof self.$refs.puzzleShadow !== 'undefined') {
            setTimeout(function () {
              self.$refs.sliderBtn.style.left = 0;
              self.$refs.sliderBtn.style.transition = 'left 0.5s';
              self.$refs.puzzleLost.style.left = 0;
              self.$refs.puzzleLost.style.transition = 'left 0.5s';
              self.$refs.puzzleShadow.style.left = 0;
              self.$refs.puzzleShadow.style.transition = 'left 0.5s';
            }, 1000);
            self.$refs.sliderBtn.style.backgroundPosition = '0 -84px';
          }
          self.moveStart = '';

          /* 失败的回调函数 */
          self.onError();
        }
      }
    },
    /* 全局绑定滑块移动与滑动结束，移动过程中鼠标可在页面任何位置 */addMouseMoveListener: function addMouseMoveListener() {
      var self = this;
      document.addEventListener('mousemove', self.moving);
      document.addEventListener('touchmove', self.moving);
      document.addEventListener('mouseup', self.moveEnd);
      document.addEventListener('touchend', self.moveEnd);
    },
    removeMouseMoveListener: function removeMouseMoveListener() {
      var self = this;
      document.removeEventListener('mousemove', self.moving);
      document.removeEventListener('touchmove', self.moving);
      document.removeEventListener('mouseup', self.moveEnd);
      document.removeEventListener('touchend', self.moveEnd);
    }
  },
  mounted: function mounted() {
    this.initCanvas();
  },
  created: function created() {
    var imgRandomNum = this.$common.RandomNum(0, this.puzzleImgList.length - 1);
    this.imgRandom = this.puzzleImgList[imgRandomNum];
  },
  watch: {}
};